import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const APPROVE_USER = "APPROVE_USER";

export interface ApproveUserAction extends Action {
  type: typeof APPROVE_USER;
  userId: string | number;
  organization: OrganizationKeyName;
}

export const approveUserAction = (
  organization: OrganizationKeyName,
  userId: string | number
): ApproveUserAction => ({
  type: APPROVE_USER,
  organization,
  userId,
});
